import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=c6d483c4&scoped=true"
import script from "./Warranty.vue?vue&type=script&lang=js"
export * from "./Warranty.vue?vue&type=script&lang=js"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=c6d483c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d483c4",
  null
  
)

export default component.exports